// extracted by mini-css-extract-plugin
module.exports = {"analyticsPage":"Analytics_analyticsPage__Sh_00 p-5","metabaseIframe":"Analytics_metabaseIframe__2o2-p","fadeIn":"Analytics_fadeIn__2-e-q","loading":"Analytics_loading__3T8ax"};